/* eslint-disable no-unused-expressions */
import React, {Fragment} from 'react';
import './AnswerTable.scss';
import {AnswerTableAttachments} from '../AnswerTableAttachments/AnswerTableAttachments';
import {
	addAttachmentsToPrevList,
	getAttachmentsOnList,
	serializeAttachmentsForSaving,
	serializeFromDocumentToAttachment,
	serializeInitialAttachmentsForForm,
	setAllAttachmentsAsRemoved,
	setAttachmentAsRemoved
} from '../documents/helpers';
import {QuestionAnswerDto} from '../Dtos/QuestionAnswerDto';
import {ControlDto} from '../Dtos/ControlDto';
import * as validator from '../Validators/ControlValidator.js';
import * as httpService from '../HttpService/HttpService';
import * as PropertyBucket from '../../Properties/Properties.js';
import PopUp from '../PopUp/PopUp';
import {Waiter} from '../WaitingSign/Waiting';
import {Prompt} from 'react-router-dom';
import FieldsetCustom from '../FieldsetCustom/FieldsetCustom';
import RadioCustom from '../RadioCustom/RadioCustom';
import WysiwygEditor from '../WysiwygEditor/WysiwygEditor';
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';

export class AnswerTable extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showPopup: false,
			showWindow: false,
			remarksOpened: false,
			questionList: [],
			activeQuestion: null,
			activeQuestionId: null,
			forPostContInf: false,
			isWaiting: false,
			answerClasses: [],
			markCheck: 'checked',
			checkedQuestions: [],
			lockedBlocks: [],
			textAnswer: '',
			checkedNd: [],
			activateFormInfo: false,
			// attachments attributes in state
			questionInBlockIdForUpload: null,
			editedBlockInListId: null,
			editedBlockAttachments: {},

			isChangeRoutePossible: true,
			isPreventPromptEnabled: false,
			questionListSource: null,
			collaps: false,
			collapseWithId: []
		};
		this.styles = [];
		this.lockHeartbeatIntervalId = null;
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.handleDisabledPostDocumentChange = this.handleDisabledPostDocumentChange.bind(this);

	}

	componentWillUnmount() {
		this.stopLockHeartbeat();
		if (this.state.editedBlockInListId) {
			this.trySetEditLock({ id: this.state.editedBlockInListId }, false, true);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.questionList?.id !== this.props.questionList?.id) {
			const currentVersion = JSON.parse(JSON.stringify(this.props.questionList));
			this.setState({
				questionList: currentVersion,
				questionListSource: currentVersion?.blocksInList || []
			});
		}
	}

	componentDidMount() {
		const { questionList, answerBlockStatus } = this.props;
		if (!questionList?.blocksInList) return;
		const clonedQuestionList = JSON.parse(JSON.stringify(questionList));
		const blocks = clonedQuestionList.blocksInList;
		const checkedNd = blocks.map(block => {
			const ndValue = answerBlockStatus?.find(x => x.blockRef === block.id);
			const isNd = !(ndValue === undefined || ndValue.active === true);
			return {
				blockId: block.id,
				blockInListId: block.id,
				blockAnswer: isNd,
				blockAnswerOld: isNd
			};
		});
		const collapseWithId = blocks.map(block => ({
			id: block.id,
			isCollapsed: true
		}));
		this.setState({
			questionList: clonedQuestionList,
			questionListSource: JSON.parse(JSON.stringify(blocks)),
			checkedNd,
			collapseWithId
		});
	}

	checkIfDataChanged = (questions, blockId) => {
		const block = this.state.questionListSource.find(el => el.blockInListId === blockId);

		const questionsJSON = JSON.stringify(questions);
		const newQuestionsJSON = JSON.stringify(block.questionsInBlock);
		if (questionsJSON !== newQuestionsJSON) {
			if (this.state.isChangeRoutePossible) {
				this.setState({isChangeRoutePossible: false})
			}
		} else {
			if (!this.state.isChangeRoutePossible) {
				this.setState({isChangeRoutePossible: true})
			}
		}
	};

	preventChangeRoute = (newLocation) => {
		this.setState({
			showPopup: true,
			popUp: {
				title: 'Ostrzeżenie',
				notification: PropertyBucket.getCancelMessage(),
				type: 'cancel',
				newLocationLink: newLocation,
				onClickEvent: this.changeRoute,
				closePopUp: this.handleClosePopUp
			},
			isPreventPromptEnabled: false
		});

		return false;
	};

	changeRoute = () => {
		this.setState({
			isPreventPromptEnabled: false
		});

		this.state.popUp.newLocationLink && this.props.history.push(this.state.popUp.newLocationLink)
	};

	handleClosePopUp = () => {
		this.setState({
			showPopup: false,
			remarksOpened: false,
			questionInBlockIdForUpload: null,
			isPreventPromptEnabled: false
		});
	};

	handleChangeTextAnswer = (e) => {
		this.setState({
			textAnswer: e.target.value
		})
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent, link) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent, link: link}
		})

	};
	openRemarks = (question) => {
		let remarksOpened = this.state.remarksOpened;
		if (remarksOpened) {
			this.setState({
				remarksOpened: false,
				showWindow: false,
			});

		} else {
			this.setState({
				remarksOpened: true,
				showWindow: true,
			});
		}
		this.setState({
			activeQuestion: question,
			textAnswer: question.answers && (question.answers.textAnswer !== null && question.answers.textAnswer !== undefined) ? question.answers.textAnswer : ''

		});
	};

	getQuestionAnswer = (question) => {
		if (!question.answers) {
			return null
		}
		return question.answers
	};

	getQuestionAttachment = (question) => {
		const answer = this.getQuestionAnswer(question);
		return serializeInitialAttachmentsForForm(answer?.attachments || []);
	};

	handleDisabledPostDocumentChange = (disabled) => {
		this.props.onDisabledChange(disabled);
	};

	handleSaveControlList = () => {
		this.props.onSaveBlockData()
	}

	onEditBlockClick = (block) => {
		let _this = this;
		let styles = this.styles;
		styles.forEach(function (styleObject) {
			if (styleObject.blockId === block.id) {
				if (styleObject.classes.includes('locked')) {
					_this.trySetEditLock(block, true).then(function (result) {
						if (!result || result.lockedByOther !== true) {
							_this.lockBlock(block);
						}
					});
				} else if (styleObject.classes.includes('activated')) {
					_this.showPopup('Ostrzeżenie', PropertyBucket.getCancelMessage(), 'cancel', () => {
						_this.setState({
							checkedNd: _this.state.checkedNd.map(b => b.blockId === block.id ? ({...b, blockAnswer: b.blockAnswerOld}) : b)
						});
						_this.stopLockHeartbeat();
						_this.trySetEditLock(block, false, true);
						_this.lockBlock(block);
					}, null)
				}
			}
		});
	};
	
	trySetEditLock = (block, lock, silent = false) => {
		const blockId = block.id;

		const this_ = this;

		this.isWaitingOnOff(true);

		const url = PropertyBucket.urlEditLockBlock(this.props.controlId, blockId);
		const payload = {
			lock: lock
		};
		const callPromise = httpService.getServicePromise(url, 'POST', payload, true);

		return callPromise.then(
			function () {
				this_.isWaitingOnOff(false);
				return { lockedByOther: false };
			}
		).catch(function (error) {
			this_.isWaitingOnOff(false);
			if (error && (error.status === 400 || error.status === 422)) {
				if (lock) {
					if (!silent) {
						const errorMessages = {
							400: 'Inny użytkownik aktualnie edytuje ten blok. Spróbuj ponownie później.',
							422: 'Lista sprawdzająca została zmieniona. Strona zostanie odświeżona.'
						 }
						this_.showPopup('Komunikat', errorMessages[error.status], 'error',  error.status === 422 && (() => window.location.reload()));
					}
					return { lockedByOther: true };
				}
				return { lockedByOther: false };
			}
			console.log(error);
			return { lockedByOther: true };
		});
	}

	startLockHeartbeat = (block) => {
		this.stopLockHeartbeat();
		const intervalMs = 25 * 60 * 1000;
		this.lockHeartbeatIntervalId = setInterval(() => {
			this.extendEditLock(block);
		}, intervalMs);
	}

	extendEditLock = (block) => {
		const blockId = block.id;
		const url = PropertyBucket.urlEditExtendLockBlock(this.props.controlId, blockId);
		return httpService.getServicePromise(url, 'POST', {}, true)
			.then(() => ({ lockedByOther: false }))
			.catch(() => ({ lockedByOther: true }));
	}

	// Fetch latest answers for the given block and update questions and attachments
	fetchLatestBlockAnswers = (block) => {
		const controlId = this.props.controlId;
		const blockId = block.id;

		const url = PropertyBucket.getControlBlockQuestions(controlId, blockId);

		this.isWaitingOnOff(true);

		return httpService.getService(url, 'GET')
			.then((answers) => {
				if (!answers) { return null; }
				const docsUrl = PropertyBucket.getControlDocumentsList(this.props.controlUuid);
				return httpService.getService(docsUrl, 'GET')
					.then(docsData => ({ answers, docsData }));
			})
			.then((payload) => {
				if (!payload) { return; }
				const { answers, docsData } = payload;
				// Normalize documents array
				const documentsArray = Array.isArray(docsData?.documents) ? docsData.documents : (Array.isArray(docsData) ? docsData : []);
				const attachmentIdToDocument = new Map();
				for (let doc of documentsArray) {
					const docAttachments = doc.attachments || [];
					for (let att of docAttachments) {
						attachmentIdToDocument.set(att.id, doc);
					}
				}
				// Enrich answers attachments with up-to-date document objects
				(answers || []).forEach(ans => {
					(ans.attachments || []).forEach(att => {
						if (att?.document?.referenceId) {
							const docById = documentsArray.find(d => d.id === att.document.referenceId);
							if (docById) { att.document = docById; }
						} else if (att?.id && attachmentIdToDocument.has(att.id)) {
							att.document = attachmentIdToDocument.get(att.id);
						}
					});
				});

				const answersByQuestionId = new Map(
					(answers || []).map(el => [el?.questionInBlock?.referenceId, el])
				);

				this.setState(prevState => {
					const questionList = JSON.parse(JSON.stringify(prevState.questionList || { blocksInList: [] }));
					const questionListSource = JSON.parse(JSON.stringify(prevState.questionListSource || []));
					const updatedBlocks = (questionList.blocksInList || []).map(b => {
						if (b.id !== blockId) {
							return b;
						}
						return {
							...b,
							questionsInBlock: (b.questionsInBlock || []).map(q => {
								const freshAnswer = answersByQuestionId.get(q.id);
								return {
									...q,
									answers: freshAnswer || q.answers
								};
							})
						};
					});
					questionList.blocksInList = updatedBlocks;

					const idx = questionListSource.findIndex(el => el.blockInListId === blockId);

					if (idx !== -1) {
						const updatedBlock = updatedBlocks.find(b => b.id === blockId);
						if (updatedBlock) {
							questionListSource[idx] = JSON.parse(JSON.stringify(updatedBlock));
						}
					}
					
					return { questionList, questionListSource };
				});

				// Rebuild edited attachments for this block if it's currently being edited
				if (this.state.editedBlockInListId === blockId) {
					const updatedBlock = this.state.questionList?.blocksInList?.find(b => b.id === blockId) || block;
					let editedBlockAttachments = {};
					for (let question of updatedBlock.questionsInBlock || []) {
						editedBlockAttachments[question.id] = this.getQuestionAttachment(question);
					}
					this.setState({ editedBlockAttachments });
				}
			})
			.finally(() => this.isWaitingOnOff(false));
	}

	stopLockHeartbeat = () => {
		if (this.lockHeartbeatIntervalId) {
			clearInterval(this.lockHeartbeatIntervalId);
			this.lockHeartbeatIntervalId = null;
		}
	}

	lockBlock = (block) => {
		const blockId = block.id;
		let styles = this.styles;
		let preparePostDocument;
		const this_ = this;
		styles.forEach(function (styleObject) {
			let blockIndex = styleObject.blockId;
			if (blockIndex === blockId) {
				if (styleObject.classes.includes('locked')) {
					let j = styleObject.classes.indexOf('locked');
					styleObject.classes[j] = 'activated';
					document.querySelector('#edit' + blockId).innerHTML = 'ZAKOŃCZ EDYCJĘ';
					document.querySelector('#edit' + blockId + '-end').innerHTML = 'ZAKOŃCZ EDYCJĘ';
					preparePostDocument = true;

					// attachments part
					let editedBlockAttachments = {};
					for (let question of block.questionsInBlock) {
						editedBlockAttachments[question.id] =
							this_.getQuestionAttachment(question);
					}
					this_.setState({editedBlockInListId: blockId, editedBlockAttachments})
					// refresh answers from server to ensure latest state
					this_.fetchLatestBlockAnswers(block);
					this_.startLockHeartbeat(block);

				} else if (styleObject.classes.includes('activated')) {
					let k = styleObject.classes.indexOf('activated');
					styleObject.classes[k] = 'locked';
					document.querySelector('#edit' + blockId).innerHTML = 'EDYTUJ BLOK';
					document.querySelector('#edit' + blockId + '-end').innerHTML = 'EDYTUJ BLOK';
					preparePostDocument = false;
					this_.stopLockHeartbeat();

					// attachments part
					this_.setState({
						editedBlockInListId: null,
						editedBlockAttachments: {},
						questionInBlockIdForUpload: null,
					});
				}
			}
		});

		this.setState({isPreventPromptEnabled: !this.state.isPreventPromptEnabled});
		this.handleDisabledPostDocumentChange(preparePostDocument);
	};

	deactivateBlockConfirm = (blockId, event) => {
		let checked = event.target.checked;
		checked === true ? this.showPopup('Nie dotyczy bloku', PropertyBucket.getDeactivateBlockConfirmMessage(), 'confirm', () => {
			this.changeActiveBlock(blockId, 'ND');
			this.state.checkedNd[this.state.checkedNd.findIndex(el => el.blockInListId === blockId)].blockAnswer = true;
			// mark as "toRemove" all attachment for block
			this.cleanAllAttachments();
			if (this.state.isChangeRoutePossible) {
				this.setState({isChangeRoutePossible: false})
			}
		}) : this.changeActiveBlock(blockId, null)
	};


	changeActiveBlock = (blockId, value) => {
		let questionList = this.state.questionList;;
		const _this = this;
		_this.state.checkedNd[_this.state.checkedNd.findIndex(el => el.blockInListId === blockId)].blockAnswer = false;
		questionList.blocksInList.forEach(function (block) {
			if (blockId === block.id) {
				block.questionsInBlock.forEach(function (question) {
					if (!question.answers || question.answers.answer === null) {
						question.answers.answer = value;
						question.answers.textAnswer = null;
						question.answers.relevantInPostControlNote = false;
					} else {
						question.answers.answer = value;
						question.answers.textAnswer = null;
						question.answers.relevantInPostControlNote = false;
					}
				});
				if (_this.state.isChangeRoutePossible) {
					_this.setState({isChangeRoutePossible: false})
				}
				_this.checkIfDataChanged(block.questionsInBlock, block.blockInListId);
			}


		});
		this.setState({refresh: true});
	};

	deleteTextAnswer = (questionId) => {
		let _this = this;
		let questionList = this.state.questionList;;
		questionList.blocksInList.forEach(function (block) {
			block.questionsInBlock.forEach(function (question) {
				if (questionId === question.id) {
					if (question.answers) {
						question.answers.textAnswer = null;
						question.answers.relevantInPostControlNote = false;
						_this.handleCloseWindow();
					}
				}
			})
		})
	};

	saveTextAnswer = (questionId) => {
		let _this = this;
		let questionList = this.state.questionList;;
		let textAnswer = this.state.textAnswer;
		let isValidated = validator.getMustNotBeEmpty(textAnswer, 'answerWindowInputAlert');
		if (isValidated) {
			questionList.blocksInList.forEach(function (block) {
				block.questionsInBlock.forEach(function (question) {
					if (questionId === question.id) {
						if (question.answers) {
							question.answers.textAnswer = textAnswer;
							_this.handleCloseWindow();
						} else {
							let answers = [];
							let answer = new QuestionAnswerDto();
							answer.textAnswer = textAnswer;
							/*
								this one below really doesn't matter (attachments are kept in
								state), but it's safer to leave it like that, nobody knows,
								where it could be missing
							*/
							answer.attachments = [];
							answers.push(answer);
							question.answers = answers;
							_this.handleCloseWindow();
						}

						_this.checkIfDataChanged(block.questionsInBlock, block.blockInListId);
					}
				})
			})
		}
	};

	saveAnswer = (block, questionId) => (event) => {
		block.questionsInBlock.forEach(function (question) {
			if (questionId === question.id) {
				if (!question.answers || question.answers.answer === null) {
					question.answers.answer = event.target.value;
					question.answers.textAnswer = null;
				} else {
					question.answers.answer = event.target.value;
					event.target.value === 'ND' ? question.answers.relevantInPostControlNote = false : null;
				}
			}
		});

		this.checkIfDataChanged(block.questionsInBlock, block.blockInListId);
		this.setState({refresh: true});
	};

	markQuestionForPostContInf = (block, questionId) => (event) => {
		block.questionsInBlock.forEach(function (question) {
			if (questionId === question.id) {
				if (!question.answers || question.answers.length === 0) {
					let answers = [];
					let answerDto = new QuestionAnswerDto();
					event.target.checked ? answerDto.relevantInPostControlNote = true : answerDto.relevantInPostControlNote = false;
					answers.push(answerDto);
					question.answers = answers;
				} else {
					let lastAnswer = question.answers;
					event.target.checked ? lastAnswer.relevantInPostControlNote = true : lastAnswer.relevantInPostControlNote = false;
					question.answers = lastAnswer;
				}
			}
		});

		this.checkIfDataChanged(block.questionsInBlock, block.blockInListId);
		this.state.forPostContInf ? this.setState({forPostContInf: false}) : this.setState({forPostContInf: true});
	};
	showWindow = () => {
		return (
			<PopUp
				customContent
				handleClosePopup={this.handleCloseWindow}
				title={`${this.state.remarksOpened ? 'Dodawanie uwagi' : ''}`}
			>
				{this.state.remarksOpened ? this.showAnswerTab() : null}
			</PopUp>
		)
	};

	showAnswerTab = () => {
		return <div id='answerWindow'>
			<p>{this.state.activeQuestion.questionContent}</p>
			<WysiwygEditor
				name='answerArea'
				size={4000}
				value={this.state.textAnswer}
				onChange={this.handleChangeTextAnswer}
				errorId='answerWindowInputAlert'
			/>
			<div class="row">
				<div className='btn_group-left col-6'>
					<button id='deleteAnswerButton' className='btn cancel-btn' onClick={() => this.deleteTextAnswer(this.state.activeQuestion.id)}>USUŃ<span className='sr-only'> uwagę</span>
					</button>
				</div>
				<div className='btn_group col-6'>
					<button id='saveAnswerButton' className='btn save-btn right'
						onClick={() => this.saveTextAnswer(this.state.activeQuestion.id)}>ZAPISZ<span className='sr-only'> uwagę</span>
					</button>
					<button id='cancelAnswerButton' className='btn cancel-btn' onClick={() => this.handleCloseWindow()}>ANULUJ<span className='sr-only'> dodawanie uwagi</span>
					</button>
				</div>
			</div>
		</div>;
	};

	handleCloseWindow = () => {
		this.setState({
			showWindow: false,
			remarksOpened: false,
			questionInBlockIdForUpload: null,
		});
	};

	cancelSave = () => {
		this.showPopup('Ostrzeżenie', PropertyBucket.getCancelMessage(), 'cancel', null, '')
	};

	saveBlock = (block) => {
		let areAllFieldsPassed = true;
		if (areAllFieldsPassed) {
			let questionList = this.state.questionList;;

			const isBlockND = this.state.checkedNd[this.state.checkedNd.findIndex(el => el.blockInListId === block.id)].blockAnswer;

			let controlDto = new ControlDto();
			controlDto.controlId = this.props.controlId;
			controlDto.questionList = questionList;
			let questions = block.questionsInBlock;
			let answers = [];
			const { editedBlockAttachments } = this.state;
			questions.forEach((question) => {
				if (question.answers) {
					let questionAnswerDto = new QuestionAnswerDto();
					let answer = question.answers;
					questionAnswerDto.id = answer.id ? answer.id : null;
					questionAnswerDto.answer = answer.answer ? answer.answer : null;
					questionAnswerDto.textAnswer = answer.textAnswer ? answer.textAnswer : null;
					questionAnswerDto.relevantInPostControlNote = answer.relevantInPostControlNote !== null ? answer.relevantInPostControlNote : null;
					questionAnswerDto.questionInBlock = question;
					questionAnswerDto.blockId = block.id;
					questionAnswerDto.attachments = serializeAttachmentsForSaving(
						editedBlockAttachments[question.id] || []);
					answers.push(questionAnswerDto);
				} else {
					// yes, it looks odd, but answer is kept in memory values
					// (ugly solution), not in state, and the attachments are from state
					const attachments = editedBlockAttachments[
						question.id] || [];
					if (attachments.length) {
						const questionAnswerDto = new QuestionAnswerDto();
						questionAnswerDto.id = null;
						questionAnswerDto.answer = null;
						questionAnswerDto.textAnswer = null;
						questionAnswerDto.relevantInPostControlNote = null;
						questionAnswerDto.questionInBlock = question;
						questionAnswerDto.blockId = block.id;
						questionAnswerDto.attachments =
							serializeAttachmentsForSaving(attachments);
						answers.push(questionAnswerDto);
					}
				}

			});
			controlDto.answers = answers;
			controlDto.answerBlockStatus = [{blockRef: block.id, active: !isBlockND}]
			controlDto.blockId = block.id;

				let url = PropertyBucket.updateControlListBlock(this.props.controlId);
			let callPromise = httpService.getServicePromise(url, 'PUT', controlDto, true);
			let _this = this;
			this.isWaitingOnOff(true);
			callPromise.then(
				function (message) {
					return _this.fetchLatestBlockAnswers(block).catch(() => null).then(() => {
						_this.isWaitingOnOff(false);
						_this.showPopup('Komunikat', PropertyBucket.saveControlListBlockMessage(), 'notify');
						_this.stopLockHeartbeat();
						_this.lockBlock(block);
						_this.handleSaveControlList()
					})
				},
				function (error) {
					const errorMessages = {
						'CANNOT_EDIT_CONTROL_IN_ZREALIZOWANA_STATUS': 'Nie można edytować kontroli, która jest realizowana lub zakończona.',
						'CONTROL_QUESTION_LIST_CHANGED': 'Lista sprawdzająca została zmieniona. Strona zostanie odświeżona.'
					}
					if(error.status === 422) {
						_this.showPopup('Błąd', errorMessages[error.errorCode], 'error', () => {
							_this.isWaitingOnOff(false);
							_this.stopLockHeartbeat();
							_this.lockBlock(block);
							window.location.reload();
						});
					} else {
						_this.isWaitingOnOff(false);
						_this.showPopup('Błąd', error.message ? error.message : error, 'error');
						_this.stopLockHeartbeat();
						_this.lockBlock(block);
					}
				}
			)
		}
	};

	handleAddAttachments = (questionInBlockId, documentList) => {
		if (!documentList) {
			this.handleCloseWindow();
			return
		}

		const attachments = documentList.map(
			document => serializeFromDocumentToAttachment(document));
		this.setState(
			prevState => {
				const prevQuestionAttachments =
					prevState.editedBlockAttachments[questionInBlockId] || [];
				return {
					editedBlockAttachments: {
						...prevState.editedBlockAttachments,
						[questionInBlockId]: addAttachmentsToPrevList(
							prevQuestionAttachments, attachments),
					}
				}
			},
			this.handleCloseWindow
		);
	};

	handleRemoveAttachment = (questionInBlockId, documentId) => {
		this.setState(prevState => {

			return {editedBlockAttachments: {
				...prevState.editedBlockAttachments,
				[questionInBlockId]: setAttachmentAsRemoved(
					prevState.editedBlockAttachments[questionInBlockId] || [], documentId),
			}}
		})
	};

	cleanQuestionAttachments = (questionInBlockId, callback) => {
		this.setState(
			prevState => ({
				editedBlockAttachments: {
					...prevState.editedBlockAttachments,
					[questionInBlockId]: setAllAttachmentsAsRemoved(
						prevState.editedBlockAttachments[questionInBlockId] || []),
				}
			}), callback
		);
	};

	cleanAllAttachments = () => {
		// don't remove them, just set "toRemove" value to false
		this.setState(
			prevState => {
				let editedBlockAttachments = {};
				for (let [key, value] of Object.entries(prevState.editedBlockAttachments)) {
					editedBlockAttachments[key] = value.map(attachment => {
						attachment.toRemove = true;
						return attachment
					});
				}
				return {editedBlockAttachments}
			}
		);
	};  

	renderQuestion = (question, block, disabled, index) => {
		const { id } = question;

		const isEditedBlock =
			this.state.editedBlockInListId === block.id;
		// get attachments
		const attachmentsOnList = isEditedBlock
			? getAttachmentsOnList(
				this.state.editedBlockAttachments[id] || [])
			: this.getQuestionAttachment(question);

		const lastAnswer = question.answers ? question.answers.answer : null;
		const yesAnswerChecked = lastAnswer === 'TAK';
		const noAnswerChecked = lastAnswer === 'NIE';
		const ndAnswerChecked = lastAnswer === 'ND';
		return (
			<Fragment key={'question-' + question.id}>
				<tr className='quest-row' key={'question-row-' + question.id}>
					<td>{++index}</td>
					<td id={'cell' + question.orderNumber}>
						<FieldsetCustom
							legend={question.questionContent}
							legendClassName='legend'
							wrapperClassName='fieldset-content-wrapper--answers'
							wrapperRow
						>
							<RadioCustom
								name={'answer' + question.id}
								checked={yesAnswerChecked}
								value='TAK'
								onChange={this.saveAnswer(block, id)}
								label='TAK'
								id={`answer1_${question.id}`}
								disabled={disabled}
							/>
							<RadioCustom
								name={'answer' + question.id}
								checked={noAnswerChecked}
								value='NIE'
								onChange={this.saveAnswer(block, id)}
								label='NIE'
								id={`answer2_${question.id}`}
								disabled={disabled}
							/>
							<RadioCustom
								name={'answer' + question.id}
								checked={ndAnswerChecked}
								value='ND'
								onChange={ev => {
									// clean attachments
									this.cleanQuestionAttachments(
										id,
										() => this.saveAnswer(block, id)(ev)
									);
								}}
								label='ND'
								id={`answer3_${question.id}`}
								disabled={disabled}
							/>
						</FieldsetCustom>
					</td>
					<td>
						<button
							className='btn save-btn px-1 answerButtons'
							disabled={disabled || (!yesAnswerChecked && !noAnswerChecked && !ndAnswerChecked)}
							onClick={() => this.openRemarks(question)}
						>
							UWAGI
						</button>
						<button
							className='btn save-btn second-btn px-0 answerButtons'
							disabled={disabled || ndAnswerChecked || (!yesAnswerChecked && !noAnswerChecked)}
							onClick={() => this.setState(
								{questionInBlockIdForUpload: id})}
						>
							PLIKI
						</button>
					</td>
				</tr>
				{question.answers && (question.answers.textAnswer !== null && question.answers.textAnswer !== undefined) ?
					(<tr className='quest-second-row'>
						<td colSpan='4'>
							<hr/>
							<p><span
								className='font-weight-bold'>UWAGA: </span> <div dangerouslySetInnerHTML={{ __html: draftjsToHTML(question.answers.textAnswer) }} />
							</p>
							<p>
								<input type='checkbox' className='markCheck' id={`margCheck_${question.id}`}
											 disabled={disabled}
											 value={this.state.forPostContInf}
											 defaultChecked={question.answers && question.answers.relevantInPostControlNote === true}
											 onChange={this.markQuestionForPostContInf(block, question.id)}/>
								<label htmlFor={`margCheck_${question.id}`}>DODAJ DO DOKUMENTU POKONTROLNEGO</label>
							</p>
						</td>
					</tr>) : null}
				<AnswerTableAttachments
					attachments={attachmentsOnList}
					canRemove={isEditedBlock}
					controlUuid={this.props.controlUuid}
					openDocuments={isEditedBlock &&
						this.state.questionInBlockIdForUpload === id
					}
					projectUuid={this.props.projectUuid}
					onAdd={documentList =>
						this.handleAddAttachments(question.id, documentList)
					}
					onCloseDocuments={this.handleCloseWindow}
					onRemove={documentId =>
						this.handleRemoveAttachment(id, documentId)
					}
				/>
			</Fragment>
		)
	};

	renderQuestions = (block, styleObjectIndex, disabled, allChecked, _this, handleEditClick, disabledEdit, handleSaveClick) => {
		const sortedQuestions = block.questionsInBlock.sort((a, b) => a.orderNumber - b.orderNumber);
		return (
			<table
				className={this.styles[styleObjectIndex] ? this.styles[styleObjectIndex].classes.join(' ') : null}
				id='answerTable'
			>
				<tbody>
				<tr id='titleRow'>
					<td className='width-100'>LP</td>
					<td>PYTANIE/ODPOWIEDŹ</td>
					<td className='width-100'>AKCJE</td>
				</tr>
				{sortedQuestions.map((question, index) =>
					this.renderQuestion(question, block, disabled || allChecked, index)
				)}
				</tbody>
			</table>
		)
	};

	renderAnswerTable = (blocks) => {
		let _this = this;
		let styleObject;
		let newClasses = [];
		class StyleClasses {
			constructor(blockId, classes) {
				this.blockId = blockId;
				this.classes = classes;
			}
		}

		return (<Fragment>
			{
				blocks.map(function (block, index) {
					styleObject = new StyleClasses(block.id, []);
					styleObject.classes.push('locked');
					newClasses.push(styleObject);
					_this.styles.length === 0 ? _this.styles = newClasses : null;
					let checked = _this.state.checkedNd.length > 0 ? _this.state.checkedNd.filter(el => el.blockId === block.id)[0]?.blockAnswer : false;
					let disabled = _this.styles[index].classes[0] === 'locked' ? true : false;
					let disabledEdit = false;
					if (_this.styles.some(item => item.classes[0] === 'activated') || _this.props.isLocked === false) {
						disabledEdit = disabled;
					}

					const handleSaveClick = () => {
						_this.state.checkedNd.filter(el => el.blockId === block.id)[0].blockAnswerOld = _this.state.checkedNd.filter(el => el.blockId === block.id)[0].blockAnswer
					}

					const handleEditClick = (event) => {
						_this.onEditBlockClick(block, event);
						if (disabled) {
							_this.setState({activateFormInfo: true});
						}
						setTimeout(() => {
							_this.setState({activateFormInfo: false})
						}, 3000);
					};

					const getIsCollapsedById = (id)  => {
						return _this.state.collapseWithId.find(x => x.id === id)?.isCollapsed;
					}

					const handleTitleClick = (id) => {
						const collapseWithId = _this.state.collapseWithId.map(x => {
							if (x.id === id) {
								x.isCollapsed = !x.isCollapsed;
							}
							return x;
						});

						_this.setState({ collapseWithId: collapseWithId });
					}

					return <div id={'block-' + block.id} key={'block-' + block.id}>

						<h4 className={'block_title ' + (checked && 'not_concerned')}
							onClick={() => handleTitleClick(block.id)}
						    key={'block-title-' + block.id}> 
							{(index + 1) + '. ' + block.name}
							<div className="float-right">
								{getIsCollapsedById(block.id) ?
									(<i aria-hidden="true" className="v-icon material-icons white">keyboard_arrow_left</i>) :
									(<i aria-hidden="true" className="v-icon material-icons white">keyboard_arrow_down</i>) 
								}
							</div>
						</h4>
						<div className={(getIsCollapsedById(block.id) ? 'block_content' : '')}>
							<div className='block_title-container'>
								<button className='btn save-btn my-3' id={'edit' + block.id}
									onClick={handleEditClick}
									disabled={disabledEdit} aria-label={disabledEdit ? 'Edytuj blok. Przycisk nieaktywny, aby go aktywować, zapisz lub zakończ edycję w innym bloku.' : null}>EDYTUJ BLOK
								</button>
							<button className='btn save-btn' onClick={() => {_this.saveBlock(block); handleSaveClick()}} disabled={disabled}>ZAPISZ BLOK</button>
								<div className='block_title__checkbox'>
									<input type='checkbox' className='markCheckBlock' id={'dectivate' + block.id} checked={checked} onChange={(event) => _this.deactivateBlockConfirm(block.id, event)} disabled={disabled} />
									<label htmlFor={'dectivate' + block.id} className='ml-4'>Nie dotyczy </label>
								</div>
							</div>
							{_this.renderQuestions(block, index, disabled, checked, _this, handleEditClick, disabledEdit, handleSaveClick )}
							<button className='btn save-btn my-3 ml-0' id={'edit' + block.id + "-end"}
								onClick={handleEditClick}
								disabled={disabledEdit} aria-label={disabledEdit ? 'Edytuj blok. Przycisk nieaktywny, aby go aktywować, zapisz lub zakończ edycję w innym bloku.' : null}>EDYTUJ BLOK
							</button>
							<button className='btn save-btn' style={{marginLeft: '20px'}} onClick={() => {_this.saveBlock(block); handleSaveClick()}} disabled={disabled}>ZAPISZ BLOK</button>
						</div>
					</div>
				})
			}
		</Fragment>);
	};

	render() {
		let blocks = this.state.questionList?.blocksInList || [];
		if (!blocks.length) {
			return <p>Nie ma bloków</p>
		}

		const { popUp } = this.state;
		return (
			<div>
				{this.renderAnswerTable(blocks)}
				{this.state.activateFormInfo && <span className='sr-only' role='alert'>Formularz edycji bloku jest aktywny</span>}
				{this.state.showPopup &&
					<PopUp
						link={popUp.link ? popUp.link : null}
						notification={popUp.notification}
						title={popUp.title}
						type={popUp.type}
						closePopUp={this.handleClosePopUp}
						onClickEvent={popUp.onClickEvent}
					/>
				}
				{this.state.showWindow && this.showWindow()}
				<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>
				{this.state.isPreventPromptEnabled && <Prompt when={!this.state.isChangeRoutePossible} message={this.preventChangeRoute}/>}
			</div>
		);
	}
}
